import { Box, HStack, keyframes } from "@chakra-ui/react";

interface LoadingDotsProps {
  color?: string;
}

const wave = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
`;

const LoadingDots = ({ color = "gray.600" }: LoadingDotsProps) => {
  const animation = `${wave} 1.2s ease-in-out infinite`;

  return (
    <HStack spacing={1}>
      <Box
        w="8px"
        h="8px"
        bg={color}
        borderRadius="full"
        animation={animation}
        style={{ animationDelay: "0s" }}
      />
      <Box
        w="8px"
        h="8px"
        bg={color}
        borderRadius="full"
        animation={animation}
        style={{ animationDelay: "0.15s" }}
      />
      <Box
        w="8px"
        h="8px"
        bg={color}
        borderRadius="full"
        animation={animation}
        style={{ animationDelay: "0.3s" }}
      />
    </HStack>
  );
};

export default LoadingDots;
